import type { RevaluationData } from '@libs/data-access/entities'
import { formatToWeekISO } from '@spa/services/utils'

import type {
  RevaluatedInputData,
  TableRevaluatedData
} from './revaluation.types'

export const getRevaluatedInputData = (
  revaluatedData: TableRevaluatedData[],
  revaluatedRestValues: RevaluationData[]
): RevaluatedInputData => {
  const weeksToKeep = revaluatedData
    .filter(({ is_complete_week: isCompleteWeek }) => !isCompleteWeek)
    .map(e => formatToWeekISO(e.week))

  const incompleteRevaluatedRestValues = revaluatedRestValues.filter(
    weekData => {
      const [week] = Object.entries(weekData)[0]
      return weeksToKeep.includes(week)
    }
  )

  return incompleteRevaluatedRestValues.reduce((memo, entry) => {
    const [week, value] = Object.entries(entry)[0]

    return { ...memo, [week]: { value: Number(value).toFixed(2) } }
  }, {})
}
